export enum CURRENCY {
  usd = '$',
  egp = 'EGP'
}
